import * as signalR from "@microsoft/signalr";
import { urlConfig } from "./baseUrl";

export const createConnection = (senderId) => {
  return new signalR.HubConnectionBuilder()
    .withUrl(`${urlConfig.baseUrl}/chatHub?senderId=${senderId}`)
    .withAutomaticReconnect()
    .build();
};

export const createNotificationConnection = (userId) => {
  return new signalR.HubConnectionBuilder()
    .withUrl(`${urlConfig.baseUrl}/notificationHub?userId=${userId}`)
    .withAutomaticReconnect()
    .build();
};
